import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from './context/auth/AuthContext';
import { UserProvider } from './context/user_context/UserContext';
import { OrganizationProvider } from './context/organization_context/OrganizationContext';
import { LoadingProvider } from './context/loading/LoadingContext';
import { ToastProvider } from './context/toast/ToastContext';
import { GeneralDocumentProvider } from './context/general_document_context/GeneralDocumentContext';
import { AppThemeProvider } from './context/theme_context/ThemeContext';
import { SubscriptionProvider } from './context/subscription_context/SubscriptionContext';
import { SignOutProvider } from './context/sign_out_context/SignOutContext';
import { EmployeeProvider } from './context/employee_context/EmployeeContext';
import { InventoryProvider } from './context/inventory_context/InventoryContext';
import { ProductsProvider } from './contexts/ProductsContext';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import AppRouter from './components/routes/AppRouter';
import Chatbot from './components/chat_bot/ChatBot';
import "react-big-calendar/lib/css/react-big-calendar.css";
import { GoogleCalendarProvider } from './context/google_calendar/GoogleCalendarContext';

//TODO: DUnno if we need this...
const stripePromise = loadStripe('pk_test_51P3ORHJkH6IDZjl9kiUjjlnl4HnaZfct70bmpCYY7nmRBI18CfFDosE4QX1qWvjDPpT3EW0AhJSvOYxSg2MuFsJk00KfMB3zo4');

function App() {
  return (
    <Elements stripe={stripePromise}>
      <div className="app">
        <AppThemeProvider>
          <LoadingProvider>
            <ToastProvider>
              <AuthProvider>
                <UserProvider>
                  <EmployeeProvider>
                    <GeneralDocumentProvider>
                      <OrganizationProvider>
                        <InventoryProvider>
                          <ProductsProvider>
                            <SubscriptionProvider>
                                <SignOutProvider>
                                  <GoogleCalendarProvider>
                                    <Router>
                                      <Chatbot />
                                      <AppRouter />
                                      {/* <RouteDebugger /> */}
                                    </Router>
                                  </GoogleCalendarProvider>
                                </SignOutProvider>
                            </SubscriptionProvider>
                          </ProductsProvider>
                        </InventoryProvider>
                      </OrganizationProvider>
                    </GeneralDocumentProvider>
                  </EmployeeProvider>
                </UserProvider>
              </AuthProvider>
            </ToastProvider>
          </LoadingProvider>
        </AppThemeProvider>
      </div>
    </Elements>
  );
}

export default App;